export default __webpack_public_path__ + "static/media/decrease_quantity.9e2c5a02.png";